import React from "react";
import PropTypes from "prop-types";
import { convertAmountToFrontend } from "../../helpers/convert";
import { useTranslation } from "react-i18next";

export default function SubTotal(props) {
  let { subTotals, columnCount } = props;
  const { t } = useTranslation();

  function mapToTd(value, index) {
    var subTotal = subTotals.find((item) => item.sumIndex === index);

    if (subTotal) {
      return (
        <td
          key={index}
          className={subTotal.class != null ? subTotal.class : ""}
          style={{
            fontWeight: 600,
          }}
        >
          {parseInt(subTotal.totalCount) >= 0 &&
          parseInt(subTotal.countInPage) >= 0
            ? convertAmountToFrontend(subTotal.countInPage) +
              "/" +
              convertAmountToFrontend(subTotal.totalCount)
            : convertAmountToFrontend(subTotal.totalCount)}
        </td>
      );
    }
    return (
      <>
        {index === 0 ? (
          <td
            className="sub-total-left"
            style={{
              fontWeight: 600,
            }}
          >
            {t("pages.default.organisationRegistration.table.generalTotal")}
          </td>
        ) : (
          <td key={index}></td>
        )}
      </>
    );
  }
  return (
    <tr>
      {/* <td className="sub-total-left">Genel Toplam</td> */}
      {Array(columnCount).fill(null).map(mapToTd)}
    </tr>
  );
}

SubTotal.propTypes = {
  subTotals: PropTypes.array,
  columnCount: PropTypes.number,
};
SubTotal.defaultProps = {
  columnCount: 0,
  subTotals: [],
};
